import { useMutation } from '@tanstack/react-query';
import { useAPIErrorHandler } from '../../../../../components/hooks/useAPIErrorHandler';
import { getTemplatePreviewUrl } from '../api';
import { getData } from '../../../../../utils/functional/fp';

export function useGetTemplatePreviewUrl() {
  const apiErrorHandler = useAPIErrorHandler();
  return useMutation({
    mutationFn: ({
      pdfCatalogId,
      productKey,
    }: {
      pdfCatalogId: string;
      productKey: string;
    }) =>
      getTemplatePreviewUrl(pdfCatalogId, {
        params: { productKey },
      }).then(getData),
    onError: apiErrorHandler('Failed to get template preview url'),
  });
}
